import React from 'react';
import Button from '../common/Button';
import Assets from '../../Assets';
import buildResourcePath from '../../buildResourcePath';

export default class HomeContentBox extends React.Component {

    state = {
        sliderImageIndex: 0,
        overviewBoxView: '',
        productSerialNumber: '',
        modalVisible: false
    }

    sliderElement = null;
    sliderAnimator = null;

    constructor(props) {
        super(props);
        if (this.hasProjectsForOverview()) {
            this.state.overviewBoxView = 'projects';
        } else if (this.hasConfigurationsForOverview()) {
            this.state.overviewBoxView = 'configurations';
        }
    }

    render() {
        if (this.isOverviewBox()) {
            return this.renderOverviewBox();
        }

        if (this.isSparePartsFinder()) {
            return this.renderSparePartsFinderBox();
        }

        return this.props.box.size === 'Small' ? this.renderSmall() : this.renderBig();
    }

    renderSmall() {
        let imageURL = this.props.box.files[0];
        const contentBoxClasses = ['content-box-body'];
        if (imageURL) {
            imageURL = Assets.home01;
            contentBoxClasses.push('--with-small-image');
        }
        return (
            <div>
                <div className="content-box --small">
                    <div className="content-box-header">
                        {this.renderTitle()}
                    </div>
                    <div className={contentBoxClasses.join(' ')}>
                        {this.renderContent()}
                        {imageURL && <div className="small-img">
                            <img src={imageURL}/>
                        </div>}
                    </div>
                    {this.canShowReadMore() && <div className="content-box-footer">
                        <Button onClick={() => this.onClickReadMore()}>{__('Read more')}</Button>
                    </div>}
                </div>
            </div>
        )
    }

    renderBig() {
        return (
            <div>
                <div className={`content-box ${this.props.box.slug} --big`}>
                    <div className="content-box-header">
                        {this.renderTitle()}
                        {this.renderTitleSlider()}
                    </div>
                    <div className="content-box-body">
                        {this.renderSlider()}
                        {this.renderContent()}
                    </div>
                    {this.canShowReadMore() && <div className="content-box-footer">
                        <Button onClick={() => this.onClickReadMore()}>{__('Read more')}</Button>
                    </div>}
                </div>
            </div>
        )
    }

    renderTitle = () => (
        <span className="title">{this.props.box.title}</span>
    )

    renderTitleSlider = () => {
        if (this.canShowSliderNavigations()) {
            return (
                <div className="homepage-big-content-box-bullets">
                    {this.props.box.files.map((url, urlIndex) => (
                        <div key={urlIndex}
                             className={this.state.sliderImageIndex === urlIndex ? 'attr--active' : null}></div>
                    ))}
                </div>
            )
        }

        return <React.Fragment/>
    }

    renderContent = () => (
        <div className="content"
             dangerouslySetInnerHTML={{__html: this.props.box.teaser || this.props.box.content}}></div>
    )

    canShowReadMore() {
        return this.props.box.readMoreLink || (this.props.box.teaser && this.props.box.content);
    }

    onClickReadMore() {
        if (this.props.box.teaser && this.props.box.content) {
            this.props.openInModalClick(this.props.box);
        } else if (this.props.box.readMoreLink) {
            window.open(this.props.box.readMoreLink)
        }
    }

    canShowSliderNavigations = () => this.props.box.files.length > 1;

    renderSlider() {
        const imageURLs = this.props.box.files;
        const canShowSliderNavigations = this.canShowSliderNavigations();
        let imageURL = this.props.box.files[0];
        console.log(this.props.box.files)
        if (imageURL) {
            imageURL = Assets.cetePhoto2;
        }

        return (
            <React.Fragment>
                <div className="homepage-big-content-box">
                    {canShowSliderNavigations &&
                        <div className="homepage-big-content-box-navigation-prev" onClick={() => {
                            if (this.state.sliderImageIndex > 0) {
                                this.setState(state => ({
                                    sliderImageIndex: state.sliderImageIndex - 1
                                }), () => {
                                    this.sliderAnimator.navigate(-1);
                                });
                            }
                        }}>
                            <img src={Assets.arrowDownBlue}/>
                        </div>}

                    <div className="homepage-big-content-box-slider">
                        <div ref={element => {
                            if (this.sliderAnimator === null) {
                                this.sliderElement = element;
                                this.sliderAnimator = new SliderAnimator(element);
                            }
                        }}>
                            {/* {imageURLs.map(url => (
                                <div key={url}>
                                    <img src={url} />
                                </div>
                            ))} */}
                            {imageURL && <div><img src={imageURL}/></div>}
                        </div>
                    </div>

                    {canShowSliderNavigations &&
                        <div className="homepage-big-content-box-navigation-next" onClick={() => {
                            if (this.state.sliderImageIndex < imageURLs.length - 1) {
                                this.setState(state => ({
                                    sliderImageIndex: state.sliderImageIndex + 1
                                }), () => {
                                    this.sliderAnimator.navigate(1);
                                });
                            }
                        }}>
                            <img src={Assets.arrowDownBlue}/>
                        </div>}
                </div>
            </React.Fragment>
        );
    }

    renderOverviewBoxProjectsTable() {
        if (!this.hasProjectsForOverview()) {
            return <React.Fragment/>
        }

        return (
            <table className="homepage-overview-content-box-table">
                <thead>
                <tr>
                    <th></th>
                    <th>{__('Name')}</th>
                    <th>{__('Last edited')}</th>
                    {this.props.box.canSeePrice && <th>{__('PPL')}</th>}
                </tr>
                </thead>

                <tbody>
                {this.props.box.projects.map((project, i) => (
                    <tr key={i}>
                        <td className="project-type" align="right">
                            <div className={`bubble project-tag-${project.type.toLowerCase()}`}></div>
                        </td>
                        <td className="project-name">
                            <a href={project.url} target="_blank">
                                <strong>{project.name}</strong>
                            </a><br/>
                            {project.number}
                        </td>
                        <td style={{whiteSpace: 'nowrap'}}>
                            <span style={{fontWeight: '700'}}>{project.lastEditDate}</span><br/>
                            <span>{project.lastEditUserName}</span>
                        </td>
                        {this.props.box.canSeePrice && (<td style={{whiteSpace: 'nowrap', fontSize: '.9rem'}}>
                            {project.ppl}
                        </td>)}
                    </tr>
                ))}
                </tbody>
            </table>
        );
    }

    renderOverviewBoxConfigurationsTable() {
        if (!this.hasConfigurationsForOverview()) {
            return <React.Fragment/>
        }

        return (
            <div>
                <table className="homepage-overview-content-box-table">
                    <thead>
                    <tr>
                        <th>{__('Name')}</th>
                        <th>{__('Last edited')}</th>
                        {this.props.box.canSeePrice && <th>{__('PPL')}</th>}
                    </tr>
                    </thead>

                    <tbody>
                    {this.props.box.configurations.map((configuration, i) => (
                        <tr key={i}>
                            <td>
                                <a href={configuration.url} target="_blank">
                                    <strong>{configuration.name}</strong>
                                </a>
                            </td>
                            <td style={{whiteSpace: 'nowrap'}}>
                                <span>{configuration.lastEditDate}</span> <br/>
                                <span>{configuration.lastEditUserName}</span>
                            </td>
                            {this.props.box.canSeePrice && <td style={{whiteSpace: 'nowrap'}}>
                                {configuration.ppl}
                            </td>}
                        </tr>
                    ))}
                    </tbody>
                </table>
            </div>
        );
    }

    renderOverviewBox() {
        return (
            <div className="">
                <div className="content-box overview --big">
                    <div className="content-box-header">
                        {this.renderTitle()}
                        {this.renderOverviewSwitcher()}
                    </div>
                    <div className="content-box-body">
                        {this.state.overviewBoxView === 'projects' ? (
                            this.renderOverviewBoxProjectsTable()
                        ) : (
                            this.renderOverviewBoxConfigurationsTable()
                        )}
                    </div>
                    <div className="content-box-footer">
                        {this.renderOverviewBoxFooter()}
                    </div>
                </div>
            </div>
        );
    }

    renderOverviewSwitcher = () => (
        <div className="homepage-overview-content-box-nav">
            {this.hasProjectsForOverview() && (<div
                className={this.state.overviewBoxView === 'projects' ? 'attr--active' : null}
                onClick={() => {
                    this.setState({
                        overviewBoxView: 'projects'
                    });
                }}
            >
                {__('Projects')}
            </div>)}

            {this.hasConfigurationsForOverview() && (<div
                className={this.state.overviewBoxView === 'configurations' ? 'attr--active' : null}
                onClick={() => {
                    this.setState({
                        overviewBoxView: 'configurations'
                    });
                }}
            >
                {__('Configurations')}
            </div>)}
        </div>
    )

    hasProjectsForOverview() {
        return this.props.box.projects && this.props.box.projects.length > 0;
    }

    hasConfigurationsForOverview() {
        return this.props.box.configurations && this.props.box.configurations.length > 0;
    }

    renderOverviewBoxFooter() {
        if (this.state.overviewBoxView === 'projects') {
            return (
                <Button onClick={() => {
                    location.href = buildResourcePath('/Projects');
                }}>{__('Go to Projects')}</Button>
            )
        } else {
            return (
                <Button onClick={() => {
                    location.href = buildResourcePath('/Configurations');
                }}>{__('Go to Configurations')}</Button>
            )
        }
    }

    renderSparePartsFinderBoxFooter() {
        return <React.Fragment/>
    }

    renderSparePartsFinderBox() {
        return (
            <div>
                <div className="content-box --small">
                    <div className="content-box-header">
                        {this.renderTitle()}
                    </div>
                    <div className="content-box-body">
                        <form>
                            <div>
                                <label>{__('Product S/N')}</label>
                                <input type="text"
                                       onChange={e => this.setState({productSerialNumber: e.target.value})}></input>
                            </div>
                        </form>
                    </div>
                    <div className="content-box-footer">
                        <Button onClick={this.onSparePartsFindeSearchButtonClick}
                                theme={Button.Theme.BorderOnly}>Search</Button>
                    </div>
                </div>
            </div>

        );
    }

    onSparePartsFindeSearchButtonClick = () => {
        window.location = buildResourcePath(`SparePartsFinder?productSerialNumber=${this.state.productSerialNumber}`)
    }

    isOverviewBox() {
        return this.props.box.slug === 'overview' && (this.hasConfigurationsForOverview() || this.hasProjectsForOverview());
    }

    isSparePartsFinder() {
        return this.props.box.slug === 'spare-parts-finder';
    }
}

class SliderAnimator {
    constructor(element) {
        this.id = Math.random();
        this.element = element;
        if (element && element.firstElementChild) {
            this.singleImageWidth = element.firstElementChild.clientWidth;
        }
        this.currentX = 0;
        this.animating = false;
        this.targetImageIndex = 0;
        this.timer = 0;
        this.startX = 0;
    }

    navigate(amount) {
        this.timer = 0;
        this.startX = this.currentX;
        this.targetImageIndex += amount;

        if (this.targetImageIndex > 2) {
            this.targetImageIndex = 1;
        }

        if (this.targetImageIndex < 0) {
            this.targetImageIndex = 0;
        }

        if (!this.animating) {
            this.animating = true;
            requestAnimationFrame(this.handleAnimationFrame);
        }
    }

    handleAnimationFrame = () => {
        if (this.animating) {
            requestAnimationFrame(this.handleAnimationFrame);
        } else {
            return;
        }

        this.timer += 0.0166666666667;

        const start = this.startX;
        const end = this.singleImageWidth * this.targetImageIndex;
        const alpha = Math.min(1, this.timer / 0.15);

        this.currentX = start + (end - start) * (alpha * alpha * (3 - 2 * alpha));
        this.element.style.transform = 'translateX(-' + this.currentX + 'px)';

        if (alpha >= 1) {
            this.animating = false;
            cancelAnimationFrame(this.handleAnimationFrame);
        }
    }
}